export function numberWithCommas(x: number | string) {
  return (x || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
